<form [formGroup]="form">
  <div class="editor">
      <ngx-editor [editor]="editor" [placeholder]="'Enter here...'" formControlName="editorContent">
      </ngx-editor>
  </div>
</form>
